export default __webpack_public_path__ + "static/media/permission-snap-mobile.11d8c941.svg";